import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ScrollContext } from 'react-router-scroll-4';
import { IntlReducer as Intl, IntlProvider } from 'react-redux-multilingual'
import { PersistGate } from 'redux-persist/integration/react';
import './index.scss';
// import axios from "axios";
import translations from './constants/translations'

import App from './components/app'
import FullPageLoader from './components/common/fullPageLoader'

// import "slick-carousel/slick/slick.css"; 
// import "slick-carousel/slick/slick-theme.css";


// Store
import configureStore from './store';
const { persistor, store } = configureStore();

// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.headers.common.Authorization = `Bearer 123}`;


class Root extends React.Component {
    render() {
        return (
            <Provider store={store}>
                <PersistGate loading={<FullPageLoader/>} persistor={persistor}>
                    <IntlProvider translations={translations} locale='en'>
                        <BrowserRouter basename={'/'} >
                            <ScrollContext>
                                {/* <init> */}
                                     <App />
                                {/* </init> */}
                            </ScrollContext>
                        </BrowserRouter>
                    </IntlProvider>
                </PersistGate>
            </Provider>
        );
    }
}

ReactDOM.render(<Root />, document.getElementById('root'));


